import React from 'react'
import { useParams } from 'react-router-dom'
import { InsufficientPermissions, PaginatedTable, PaginatedTableCallbacks } from '../../common'
import { RecordsPaidTable } from './recordsTable'
import { JsonRecord, Record } from '../../../models'
import { getPaidRecords } from '../../../api'
import { getAuthUser } from '../../../helpers'
import defineAbilityFor from '../defineAbility'

export const RefundRecordsComponent = () => {
    const { date_paid, agencyId } = useParams<{ date_paid: string, agencyId: string }>()
    const ability = defineAbilityFor(getAuthUser())

    if (!ability.can('View', 'RefundRecords')) {
        return <InsufficientPermissions />
    }

    return (
        <PaginatedTable<Record, JsonRecord>
            getData={(params) => getPaidRecords({ ...params, date_paid, agencyId })}
            modelConstructor={(json: JsonRecord) => new Record(json)}
            Table={(records: Record[], callbacks: PaginatedTableCallbacks) => (
                <RecordsPaidTable callbacks={callbacks} resources={{ records }} />
            )}
            searchPlaceholder="Search by Record ID, Agency, Phone, Last Name, Confirmation #"
            title={`Records : Paid Date ${date_paid ? ` – ${date_paid}` : ''}`}
        />
    )
}
